<template>
  <div class="home">
    <Hero class="mb-3 mb-md-4" />
    <HomeServices />
    <HomeAlmacenaje class="d-none d-md-block" />
    <HomeLogistica class="d-none d-md-block" />
    <HomeControl class="d-none d-md-block" />
    <HomeServiciosPreferentes class="d-none d-md-block" />
    <HomeMejora class="d-none d-md-block" />
  </div>
</template>

<script>
import Hero from '@/components/Hero'
import HomeServices from '@/components/HomeServices'
import HomeAlmacenaje from '@/components/HomeAlmacenaje'
import HomeLogistica from '@/components/HomeLogistica'
import HomeControl from '@/components/HomeControl'
import HomeServiciosPreferentes from '@/components/HomeServiciosPreferentes'
import HomeMejora from '@/components/HomeMejora'
export default {
  name: 'home',
  components: {
    Hero,
    HomeServices,
    HomeAlmacenaje,
    HomeLogistica,
    HomeControl,
    HomeServiciosPreferentes,
    HomeMejora
  }
}
</script>
<style lang="scss"></style>
